export enum PAYMENT_TYPE  {
    INCOMING = "incoming",
    OUTGOING = 'outgoing',
    INTERNAL = 'internal',
    DELIVERED = 'delivered',
    UNDELIVERED = 'undelivered',
    REFUND = 'refund',
    FEE = 'fee',
    CARD = 'card',
    SYSTEM = 'system'
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/entity/constants/payment.type.ts